<template>
  <div id="dashboard">
    <section>
      <div class="col1">
        <div class="profile">
          <div class="create-post">
            <p>create a client</p>
            <form @submit.prevent>
              <label for="client">Client</label>
              <input
                v-model.trim="clientForm.name"
                type="text"
                placeholder="WidgetCo, Inc"
                id="client"
              />
              <button @click="createClient" class="button">Add Client</button>
            </form>
          </div>
        </div>
      </div>
      <div class="col2">
        <div v-if="clients.length">
          <div v-for="client in clients" class="post" :key="client.id">
            <h5>{{ client.name }}</h5>
            <ul>
              <li>
                <a @click="editClient(client)" class="edit-button">
                  <img src="../assets/pencil.svg" alt="Edit Client" />
                </a>
              </li>
              <li>
                <a @click="deleteClient(client)" class="delete-button">
                  <img src="../assets/trash.svg" alt="Delete Client" />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div v-else>
          <p class="no-results">There are currently no posts</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { clientsCollection } from "../firebaseConfig";
const fb = require("../firebaseConfig.js");

export default {
  data() {
    return {
      clientForm: {
        name: ""
      },
      editingClient: null
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser", "clients"])
  },
  methods: {
    createClient() {
      if (this.editingClient) {
        fb.clientsCollection
          .doc(this.editingClient)
          .update({
            name: this.clientForm.name
          })
          .then(ref => {
            this.clientForm.name = "";
            this.editingClient = null;
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        fb.clientsCollection
          .add({
            name: this.clientForm.name
          })
          .then(ref => {
            this.clientForm.name = "";
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    deleteClient(client) {
      clientsCollection.doc(client.id).delete();
    },
    editClient(client) {
      this.editingClient = client.id;
      this.clientForm.name = client.name;
    }
  }
};
</script>
